import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthProvider';

type RequireAcoesProps = {
  acoes: number[];
};

export function RequireAcoes({ acoes }: RequireAcoesProps) {
  const { user } = useAuth();
  const tem = acoes.some((a) => user?.acoes.includes(a));
  if (!tem) {
    return <Navigate to="/403" replace />;
  }
  return <Outlet />;
}
